import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { AnimatePresence, motion } from "framer-motion";
import CardWithNumber from "../generic/CardWithNumber";

const HowItWorksEngagement = () => {
  const howItWorksItems = [
    {
      number: 1,
      title: "Create Smart Links",
      subtitle: "Generate Personalized, No-Code Links Instantly",
      description:
        "Easily create deep, personalized links without any coding. Set up smart links directly from your platform or app in just a few steps, ensuring a hassle-free process that saves you time and effort. Whether it's for marketing campaigns, user onboarding, or promotions, you can customize each link to target your audience with precision.",
    },

    {
      number: 2,
      title: "Guide Users Directly",
      subtitle: "Deliver Seamless Experiences by Skipping Detours",
      description:
        "With smart links, you can guide users straight to the content they’re interested in—eliminating irrelevant pages or confusing redirects. Whether your users are interacting via social media, email, or a referral, they’ll land directly where they need to be, ensuring a smoother, more focused journey from start to finish.",
    },
    {
      number: 3,
      title: "Track & Reward",
      subtitle: "Monitor Engagement, Measure Success, and Boost Loyalty",
      description:
        "Track the performance of every link with advanced analytics. Understand user behavior, measure engagement, and see exactly how many installs, opens, and referrals your links generate. Plus, you can reward loyal users by offering personalized incentives, turning simple interactions into long-term relationships that drive growth.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"howItWorksEngagement"}>
        <Line>
          <TextWrapper>
            <Title>How it Works</Title>
            <Subtitle>
              As app developers, marketers, and product managers, we’ve
              encountered the same challenges—broken links, lost referrals, and
              lost engagement. That’s why we created Dynamic Links: to simplify
              app installs, enhance the user experience, and drive conversions
              with personalized, frictionless journeys.
            </Subtitle>
          </TextWrapper>
        </Line>
        <ItemsWrapper>
          {howItWorksItems.map((item, index) => (
            <CardWithNumber
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              description={item.description}
              number={item.number}
            />
          ))}
        </ItemsWrapper>
      </Container>
    </FullPageContainer>
  );
};

export default HowItWorksEngagement;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.lightColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.lightColorFaded7};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  @media (max-width: 990px) {
    gap: 30px;
    flex-direction: column;
  }
`;

const ItemsWrapper = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  width: 100%;

  & > * {
    max-width: 600px;
    width: 100%;
  }

  @media (max-width: 990px) {
    flex-direction: column;
    align-items: center;
    width:100%;
    flex-wrap:unset;
    & > * {
      width: 100%;

    }
  }
`;
